import type {AlertProps} from '@mantine/core';
import {Alert, Text} from '@mantine/core';
import {IconExclamationCircle} from '@tabler/icons-react';
import type {ReactNode} from 'react';

/**
 * Red "Unexpected Issue" alert for surfacing a server/request error message.
 * @registry Red error alert, hidden when no message, with dimmed detail text.
 *
 * The trailing "Stuck? ..." sentence renders only when `contactLink` is set.
 */
export interface ErrorAlertProps extends AlertProps {
  message?: string;
  error?: any;
  contactLink?: ReactNode;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  error,
  contactLink,
  ...other
}) => {
  return (
    message && (
      <Alert
        title="Unexpected Issue"
        color="red"
        variant="light"
        mt="md"
        icon={<IconExclamationCircle />}
        {...other}>
        <Text c="dimmed" size="sm" mb="md">
          {message ?? error?.message ?? JSON.stringify(error)}
        </Text>

        {contactLink && (
          <Text c="dimmed" size="sm">
            Stuck? Give it another try or {contactLink}
          </Text>
        )}
      </Alert>
    )
  );
};
